import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  LostAndFoundIssueWithCache,
  MutationUpdateLostAndFoundIssueBulkArgs,
  UpdateLostAndFoundIssueBulkResponse,
  UpdateLostAndFoundIssueInput,
  UpdateLostAndFoundIssueValuesInput,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';
import { getProperty, queryInput } from '@/utils';

import { TypedDocumentNode } from '@apollo/client';
import { UpdateLostAndFoundIssue } from '../queries/UpdateLostAndFoundIssue';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof LostAndFoundIssueWithCache]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<UpdateLostAndFoundIssueBulkResponse>;
}

// SearchLostAndFoundIssue Service
export const { updateLostAndFoundIssue, useUpdateLostAndFoundIssue } = ((): {
  updateLostAndFoundIssue: ServiceMethod;
  useUpdateLostAndFoundIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(UpdateLostAndFoundIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: Partial<UpdateLostAndFoundIssueValuesInput & { id: string }>[],
        options?: ConnectionOptions
      ): Promise<UpdateLostAndFoundIssueBulkResponse> => {
        debug.log('updatecreateLostAndFoundIssue,updateLostAndFoundIssue.input', 'INPUT', payload);
        const updates: UpdateLostAndFoundIssueInput[] =
          payload
            ?.filter(({ id }) => id)
            ?.map(({ id, ...value }) => ({
              query: [
                {
                  id: queryInput(id),
                },
              ],
              value: {
                outboundFlightNumber: value?.outboundFlightNumber || null,
                outboundFlightName: value?.outboundFlightName || null,
                outboundDatetime: value?.outboundDatetime || null,
                crewMemberEmail: value?.crewMemberEmail || null,
                crewMemberName: value?.crewMemberName || null,
                crewMemberPhone: value?.crewMemberPhone || [''],
                crewFlightName: value?.crewFlightName || null,
                description: value?.description || null,
                itemLost: value?.itemLost || null,
                tripId: value?.tripId || null,
                vehicleId: value?.vehicleId || null,
                datetime: value?.datetime || null,
                dispatcherId: value?.dispatcherId || null,
                driverId: value?.driverId || null,
                notes: value?.notes || [''],
                returnStatus: value?.returnStatus || null,
                shippingAddress: value?.shippingAddress || [''],
                shippingCity: value?.shippingCity || [''],
                shippingCost: value?.shippingCost || [0],
                shippingMethod: value?.shippingMethod || [''],
                shippingStateCode: value?.shippingStateCode || [''],
                shippingZipCode: value?.shippingZipCode || [''],
                trackingNumber: value?.trackingNumber || [''],
              },
            })) ?? [];
        const args: MutationUpdateLostAndFoundIssueBulkArgs = {
          input: {
            updates,
          },
        };
        debug.log('updateLostAndFoundIssue,updateLostAndFoundIssue.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'updateLostAndFoundIssueBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('updateLostAndFoundIssue,updateLostAndFoundIssue.response', 'RESPONSE', res);
        return getProperty('updateLostAndFoundIssueBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    updateLostAndFoundIssue: fetch,
    useUpdateLostAndFoundIssue: useService,
  };
})();
